<template lang="html">
  <div
    v-if="canAccessPage">

    <usuario-fornecedor-tabela
      class="CRUDGenerico__ContentTable"
      ref="UsuarioFornecedorTabela"
      :title="$tc('label.usuario_fornecedor', 2)"
      :table-rows="tableRows"
      :registros="tableRows"
      :limite-pagina="limitePagina"
      :paginas="paginas"
      :carregando="carregando"
      :table-header="[]"
      :visible-columns="[]"
      :mobile-invisible-columns="[]"
      :ignore-columns="[]"
      @USUARIOTABELA_EDIT="editUsuario"
      @USUARIOTABELA_EDIT_NOVO="editUsuarioNovo"
      @USUARIOTABELA_VER="verUsuario"
      @USUARIOTABELA_VER_NOVO="verUsuarioNovo"
      @USUARIOTABELA_EDIT_DADOS_SENSIVEIS="editUsuarioDadosSensiveis"
      @TABELA_BUSCAR_PROXIMA_PAGINA="requestNextPage"
      @TABELA_FILTRAR_PAGINA="filtrar"
      @TABELAGENERICA_ORDENAR="organizar"
      @PAGINACAO_ALTERANDO_TAMANHO_PAGINA="alterarTamanhoPagina"/>

    <div style="position: fixed; bottom: 16px; right: 16px; display: flex; gap: 16px; z-index: 5;">
      <v-tooltip top v-if="cadastrarGestaoFornecedor && ((canPost && !indUsuarioLogadoFornecedor) || usuarioLogado.indUsuarioExternoMaster)">
        <template v-slot:activator="{ on }">
          <v-btn id="btn_novo"
            fab
            @click="adicionarNovoFornecedor"
            color="primary"
            v-on="on">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>{{$t('label.novo_usuario')}}</span>
      </v-tooltip>
    </div>

    <v-dialog
      v-model="exibiModalCadastroNovoFornecedor"
      :max-width="larguraModal">
      <usuario-fornecedor-cadastro-dialog
        ref="cadastroNovoFornecedorDialog"
        @UsuarioFornecedorCadastroDialog__CadastrarNovoFornecedor="cadastrarNovoFornecedor"
        @UsuarioFornecedorCadastroDialog__FecharModalCadastroUsuario="fecharModalCadastroFornecedor">
      </usuario-fornecedor-cadastro-dialog>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import CRUDGenerico from '@/shared-components/generico/CRUDGenerico';
import UsuarioFornecedorTabela from '@/spa/usuario/UsuarioFornecedorTabela';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import UsuarioFornecedorCadastroDialog from './UsuarioFornecedorCadastroDialog';

export default {
  name: 'UsuarioList',
  extends: CRUDGenerico,
  data() {
    return {
      usuarioResources: this.$api.usuario(this.$resource),
      tableRows: [],
      carregando: false,
      paginas: 0,
      limitePagina: 10,
      usuario: {
        representante: {
          dependencias: {
            canaisVenda: [],
          },
        },
        superioresImediatos: [],
      },
      larguraModal: 450,
      exibiModalCadastroNovoFornecedor: false,
      aprovadorAutorizado: 'APROVADOR_AUTORIZADO',
      representanteLegal: 'REPRESENTANTE_LEGAL',
    };
  },
  computed: {
    ...generateComputed('usr', [
      'canAccessPage',
      'canPost',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    indUsuarioLogadoFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
    cadastrarGestaoFornecedor() {
      if (!this.getAllRoles) {
        return false;
      }
      // Retirar a role USR_CADASTRAR_GESTAO_DE_FORNECEDOR_MASTER quando a melhoria for subir por completo
      // Essa role chama fornecedor master mas se refere ao aprovador autorizado
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_MASTER'
          || el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_REPRESENTANTE_LEGAL'
          || el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_APROVADOR_AUTORIZADO').length;
    },
    consultarGestaoFornecedor() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'CONSULTAR_GESTAO_DE_FORNECEDOR').length;
    },
    cadastrarFornecedorRepresentanteLegal() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_REPRESENTANTE_LEGAL').length;
    },
    cadastrarFornecedorAprovadorAutorizado() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_APROVADOR_AUTORIZADO').length;
    },
  },
  components: {
    UsuarioFornecedorTabela,
    UsuarioFornecedorCadastroDialog,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage && !this.usuarioLogado.indUsuarioExternoMaster) {
        this.$router.push({ name: 'inicio' });
      }
    },
    alterarTamanhoPagina(valor) {
      this.limitePagina = valor;
      this.requestPopular({ size: valor, page: this.$refs.UsuarioFornecedorTabela.indexPagina + 1 });
    },
    filtrar(pagination) {
      this.searchQuery = pagination.filter;
      pagination.page = this.$refs.UsuarioFornecedorTabela.indexPagina + 1;
      this.requestPopular(pagination);
    },
    requestNextPage(pagina) {
      const pagination = {
        size: this.limitePagina,
        page: pagina,
        filter: this.searchQuery,
      };
      this.requestPopular(pagination);
    },
    requestPopular(page = null) {
      if (page && page.filter) {
        page.nome = page.filter;
      }
      this.request(this.usuarioResources.listar, page);
    },
    request(requisicao, page = null, cb = null) {
      const pagination = page || { size: 10, page: 1 };
      this.carregando = true;

      requisicao(pagination)
        .then((response) => {
          this.tableRows = response.data.resposta;
          const qtdeRegistros = response.data.quantidadeRegistrosPagina;
          this.paginas = Math.ceil(qtdeRegistros / pagination.size);

          this.carregando = false;
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.$error(this, err);
          this.carregando = false;
        });
    },
    editUsuario(item) {
      this.$router.push({ name: 'editarUsuarioFornecedor', params: { id: item.id, ind_possui_anexos: item.indPossuiAnexos } });
    },
    editUsuarioNovo(item) {
      let tipoFornecedor = '';
      if (!item.indUsuarioExternoMaster) {
        tipoFornecedor = this.aprovadorAutorizado;
      } else {
        tipoFornecedor = this.representanteLegal;
      }
      this.$router.push({
        name: 'editarUsuarioFornecedorNovo', params: { id: item.id, ind_possui_anexos: item.indPossuiAnexos, tipoFornecedor },
      });
    },
    verUsuario(item) {
      this.$router.push({ name: 'verUsuarioFornecedor', params: { id: item.id } });
    },
    verUsuarioNovo(item) {
      let tipoFornecedor = '';
      if (!item.indUsuarioExternoMaster) {
        tipoFornecedor = this.aprovadorAutorizado;
      } else {
        tipoFornecedor = this.representanteLegal;
      }
      this.$router.push({ name: 'verUsuarioFornecedorNovo', params: { id: item.id, tipoFornecedor } });
    },
    editUsuarioDadosSensiveis(item) {
      this.$router.push({ name: 'editarDadosSensiveisUsuarioFornecedor', params: { id: item.id } });
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    adicionarNovoFornecedor() {
      if (this.cadastrarFornecedorRepresentanteLegal && this.cadastrarFornecedorAprovadorAutorizado) {
        this.exibiModalCadastroNovoFornecedor = true;
      } else if (this.cadastrarFornecedorRepresentanteLegal && !this.cadastrarFornecedorAprovadorAutorizado) {
        this.cadastrarNovoFornecedor(this.representanteLegal);
      } else if (!this.cadastrarFornecedorRepresentanteLegal && this.cadastrarFornecedorAprovadorAutorizado) {
        this.cadastrarNovoFornecedor(this.aprovadorAutorizado);
      }
    },
    cadastrarNovoFornecedor(tipo) {
      this.$router.push({ name: 'novoUsuarioFornecedorNovo', params: { tipoFornecedor: tipo } });
    },
    fecharModalCadastroFornecedor() {
      this.exibiModalCadastroNovoFornecedor = false;
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};
</script>
